<ng-template #actions>
  <div class="sheets-rail-actions flex shrink-0 items-center gap-4">
    <!-- New workbook is a menu, as in the prototype (Wook, 2026-10-06): blank, from a template, or imported.
         Drawn as every app's rail draws its buttons (Slides' New deck): the primary "+ New" with 8px corners
         taking the room, its down arrow saying it opens a menu, then the icon-only Add. -->
    <app-button2
      appearance="primary"
      size="s"
      [height]="32"
      rounding="lg"
      class="min-w-0 flex-1"
      data-testid="sheets-new-workbook"
      stchPopover
      stchPopoverTrigger="click"
      stchPopoverPlacement="bottomLeft"
      [stchPopoverContent]="newWorkbookPopover"
      [stchPopoverShowUntil]="popoverHide"
    >
      <app-icon name="plus" size="m" />
      New workbook
      <app-icon name="chevron-down" [size]="14" />
    </app-button2>

    <app-nav-add-menu [app]="app" appearance="rail" />
  </div>
</ng-template>

<!-- The nav menu, each choice with its icon; Slides' New deck menu is drawn the same. -->
<ng-template #newWorkbookPopover>
  <app-context-menu-window>
    <app-context-menu-item
      appearance="nav"
      icon="sapphire-sheets"
      data-testid="sheets-new-blank"
      [title]="S['Blank workbook']"
      (execute)="newBlankWorkbook()"
    />
    <app-context-menu-item
      appearance="nav"
      icon="sapphire-template"
      data-testid="sheets-new-from-template"
      [title]="S['From a template']"
      (execute)="openTemplates()"
    />
    <app-context-menu-item
      appearance="nav"
      icon="upload"
      data-testid="sheets-new-import"
      [title]="S['Import spreadsheet']"
      (execute)="openImport()"
    />
  </app-context-menu-window>
</ng-template>

<!-- The dialogs live in this host (display: contents), not in the actions template: the rail would otherwise own them. -->
@if (importOpen()) {
  <app-import-dialog [busy]="importBusy()" (chosen)="importChosen($event)" (cancelled)="importOpen.set(false)" />
}

@if (templatesOpen()) {
  <app-template-chooser (chosen)="templateChosen($event)" (cancelled)="templatesOpen.set(false)" />
}
